import _classCallCheck from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/ui/text_box/texteditor_button_collection/custom.js)
 * Version: 22.1.5
 * Build date: Fri Sep 02 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../../../core/renderer";
import TextEditorButton from "./button";
import Button from "../../button";
import { extend } from "../../../core/utils/extend";
import eventsEngine from "../../../events/core/events_engine";
import { start, end } from "../../../events/hover";
import { name as clickEventName } from "../../../events/click";
var CUSTOM_BUTTON_HOVERED_CLASS = "dx-custom-button-hovered";

var CustomButton =
/*#__PURE__*/
function (_TextEditorButton) {
  _inherits(CustomButton, _TextEditorButton);

  function CustomButton() {
    _classCallCheck(this, CustomButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(CustomButton).apply(this, arguments));
  }

  _createClass(CustomButton, [{
    key: "_attachEvents",
    value: function _attachEvents(instance, $element) {
      var editor = this.editor;
      eventsEngine.on($element, start, function () {
        editor.$element().addClass(CUSTOM_BUTTON_HOVERED_CLASS);
      });
      eventsEngine.on($element, end, function () {
        editor.$element().removeClass(CUSTOM_BUTTON_HOVERED_CLASS);
      });
      eventsEngine.on($element, clickEventName, function (e) {
        e.stopPropagation();
      });
    }
  }, {
    key: "_create",
    value: function _create() {
      var editor = this.editor;
      var $element = $("<div>");

      this._addToContainer($element);

      var instance = editor._createComponent($element, Button, extend({}, this.options, {
        ignoreParentReadOnly: true,
        disabled: this._isDisabled(),
        integrationOptions: this._prepareIntegrationOptions(editor)
      }));

      return {
        $element: $element,
        instance: instance
      };
    }
  }, {
    key: "_prepareIntegrationOptions",
    value: function _prepareIntegrationOptions(editor) {
      return extend({}, editor.option("integrationOptions"), {
        skipTemplates: ["content"]
      });
    }
  }, {
    key: "update",
    value: function update() {
      var isUpdated = _get(_getPrototypeOf(CustomButton.prototype), "update", this).call(this);

      if (this.instance) {
        this.instance.option("disabled", this._isDisabled());
      }

      return isUpdated;
    }
  }, {
    key: "_isVisible",
    value: function _isVisible() {
      var editor = this.editor;
      return editor.option("visible");
    }
  }, {
    key: "_isDisabled",
    value: function _isDisabled() {
      var isDefinedByUser = void 0 !== this.options.disabled;

      if (isDefinedByUser) {
        return this.instance ? this.instance.option("disabled") : this.options.disabled;
      } else {
        return this.editor.option("readOnly");
      }
    }
  }]);

  return CustomButton;
}(TextEditorButton);

export { CustomButton as default };